// extracted by mini-css-extract-plugin
export default {"parent":"signup_parent__oqBz+","sub":"signup_sub__u-jXS","input":"signup_input__mE5iW","signup":"signup_signup__ul5Xc"};